export default __webpack_public_path__ + "static/1037-0c583a770691ac4a7ca4b8950ff0a62b.gif";